import axios from "axios";

export default {
  getAll(productoId) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/fotos-producto/${productoId}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  add(fotoProducto, file) {
    let tokenAuth = localStorage.getItem("access_token");

    let formData = new FormData();
    formData.append("fotoProductoFile", file);
    formData.append("fotoProductoJson", JSON.stringify(fotoProducto));

    return axios({
      method: "post",
      url: "api/foto-producto",
      data: formData,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: `${tokenAuth}`,
      },
    })
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  update(fotoProducto, file) {
    let tokenAuth = localStorage.getItem("access_token");

    let formData = new FormData();
    formData.append("fotoProductoFile", file);
    formData.append("fotoProductoJson", JSON.stringify(fotoProducto));

    return axios({
      method: "put",
      url: "api/foto-producto",
      data: formData,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: `${tokenAuth}`,
      },
    })
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  get(productoId, colorId) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/foto-producto/${productoId}/${colorId}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  delete(productoId, colorId) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .delete(`api/foto-producto/${productoId}/${colorId}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  //   add (fotoProducto, file) {
  //     console.log(fotoProducto);
  //     console.log(file);
  //     let formData = new FormData();
  //     formData.append('fotoProductoFile', file);
  //     formData.append('fotoProductoJson', JSON.stringify(fotoProducto));
  //     return axios.post("api/foto-producto", formData,
  //         {
  //           headers: {
  //               'Content-Type': 'multipart/form-data'
  //           }
  //         })
  //         .then((result) => {
  //           return result.data;
  //         })
  //         .catch(e => {
  //            console.log(e);
  //            throw e;
  //         })
  // },
};
